import { FC, ReactElement, useState } from 'react';

import { TabList } from '../../compositions';
import { ConnectedGiftcardBalanceForm } from '../../connectors';
import { AccountDashboardConfigTab } from '../../entities/@account/Account/Account';
import { Customer } from '../../entities/@account/Customer/Customer';
import { Address } from '../../entities/Address/Address';
import { useTrans } from '../../hooks';
import { MyAddresses, MyData } from './subcomponents';

import './AccountDashboardConfig.scss';

interface AccountDashboardConfigProps {
    successfullyAddedAddress?: boolean;
    customer: Customer;
    onUpdateCustomer: (newCustomerData: Customer) => void;
    onUpdateAddresses: (newAddressesData: Address) => void;
    onChangeShippingAddress: (addressId: string) => void;
    className?: string;
}

export const AccountDashboardConfig: FC<AccountDashboardConfigProps> = ({
    successfullyAddedAddress,
    customer,
    onUpdateCustomer,
    onUpdateAddresses,
    onChangeShippingAddress,
    className = '',
}): ReactElement => {
    const trans = useTrans();

    const [activeTab, setActiveTab] = useState<AccountDashboardConfigTab>(AccountDashboardConfigTab.myData);

    const configTabs = [
        { label: trans('containers.accountDashboardConfig.myData.title'), value: AccountDashboardConfigTab.myData },
        { label: trans('containers.accountDashboardConfig.myAddresses.title'), value: AccountDashboardConfigTab.myAddresses },
        { label: trans('containers.accountDashboardConfig.giftcard.title'), value: AccountDashboardConfigTab.giftcard },
    ];

    const handleConfigTabSelect = (value: string): void => {
        const selectedTab = value as AccountDashboardConfigTab;

        setActiveTab(selectedTab);
    };

    return (
        <div className={`account-dashboard-config ${className}`}>
            <TabList
                tabs={configTabs}
                activeTab={activeTab}
                onTabSelect={handleConfigTabSelect}
                className="account-dashboard-config__tabs"
                tabItemLabelClassName="account-dashboard-config__tabs-item-label"
            />

            {activeTab === AccountDashboardConfigTab.myData && (
                <MyData
                    customer={customer}
                    onSubmit={onUpdateCustomer}
                />
            )}

            {activeTab === AccountDashboardConfigTab.myAddresses && customer.addresses && (
                <MyAddresses
                    successfullyAddedAddress={successfullyAddedAddress}
                    addresses={customer.addresses}
                    onSubmit={onUpdateAddresses}
                    onChangeShippingAddress={onChangeShippingAddress}
                />
            )}

            {activeTab === AccountDashboardConfigTab.giftcard && (
                <ConnectedGiftcardBalanceForm />
            )}
        </div>
    );
};
